import React, { Component } from 'react'
import Axios from 'axios';
import { Link } from 'react-router-dom';
import '../../css/style.css';

import $ from 'jquery';
import Constant from '../Constant';
import { getAccessToken } from '../../hooks/AccessToken';

class Add extends Component {

    /*..................................... default state object ............................................*/

    state = {
        name: '',
        venue: '',
        price: '',
        date: '',
        time: '',
        ERROR: true
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    };


    /*.................. Integrate API for update banner...............................................*/

    handleSubmit = async event => {
        try {
            event.preventDefault();
            let token = getAccessToken();
            let metaData = {
                'name': this.state.name,
                'venue': this.state.venue,
                'price': this.state.price,
                'date': this.state.date,
                'time': this.state.time
            }

            Axios.post(Constant.apiBasePath + 'event/create', metaData, { headers: { 'token': token } }).then(response => {
                const getResults = response.data.message;

                if (response.data.status === Constant.statusSuccess) {
                    $('#gen-message').text(getResults);
                    $('#gen-message').css('color', 'green');
                    setTimeout(function () { window.location.href = '/event-management'; }, 3000);
                }

                else {
                    $('#gen-message').text(getResults);
                    $('#gen-message').css('color', 'red');
                    return false;
                }

            });
        }
        catch (err) {
            console.log(err);
        }
    }


    /*.................................end API .................................................................*/

    render() {

        return (
            <div className="content-page contest-add-update-page event-consistent-page">
                <div className="content page-content-spaced">
                    <div className="event-management-header">
                        <div className="header-content">
                            <div className="header-title">
                                <h4 className="page-title-heading">Add New Event</h4>
                                <p className="header-subtitle">Create event details, schedule, and pricing.</p>
                            </div>
                            <div className="header-actions">
                                <Link to="/event-management" className="btn openmic-link-btn">Back to Event Management</Link>
                            </div>
                        </div>
                    </div>

                    <div className="event-management-body">
                        <div className="row">
                            <div className="col-12 contest-form-column">
                                <div className="card contest-form-card">
                                    <div className="card-body contest-form-card-body">
                                <form onSubmit={this.handleSubmit}>
                                    <p id="gen-message" className="message-feedback"></p>

                                    <div className="form-row">
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="name">Event Name <span className="required">*</span></label>
                                                <input type="text" id="name" className="form-control" placeholder="Enter event name" onChange={this.handleChange} required />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="venue">Venue <span className="required">*</span></label>
                                                <input type="text" id="venue" className="form-control" placeholder="Enter venue location" onChange={this.handleChange} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="price">Price <span className="required">*</span></label>
                                                <input type="number" id="price" className="form-control" placeholder="Enter ticket price" onChange={this.handleChange} required />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="date">Date <span className="required">*</span></label>
                                                <input type="date" id="date" className="form-control" onChange={this.handleChange} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="time">Time <span className="required">*</span></label>
                                                <input type="time" id="time" className="form-control" onChange={this.handleChange} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex" style={{ gap: '10px', marginTop: '30px' }}>
                                        <button type="submit" className="btn btn-primary btn-add-event contest-add-match">+ Create Event</button>
                                        <Link to="/event-management" className="btn openmic-link-btn">Cancel</Link>
                                    </div>
                                </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Add;